import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { EMPTY, Observable } from 'rxjs';
import { Product, ProductCtor } from '../models/product.model';
import { ApiResponse } from '../models/factory.model';
import { of } from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';
import { Client } from '../models/client.model';
import { Country } from '../models/country.model';
import { LegalForm } from '../models/legalForm.model';
import { expand, takeWhile } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { ProductType } from '../models/order.model';


@Injectable({
  providedIn: 'root',
})
export class ProductService {
  private apiRoot = environment.crmTest ;
  private apiRootRED = environment.crmTest;
  headers = new HttpHeaders({
    'Content-Type': 'application/json',
  });
  constructor(private http: HttpClient) {}
 
  postFile(fileToUpload: any): Observable<any> {
    const endpoint = 'https://aws.fractalite.com/s3/upload';
    const formData: FormData = new FormData();
    for (let i = 0; i < fileToUpload.length; i++) {
      formData.append('files', fileToUpload[i], fileToUpload[i].name);
    }
  
    return this.http.post(endpoint, formData, { headers: {} }).pipe(
      map((res: ApiResponse<any>) => {
        return res;
      })
    );
  }
  
  
 
  

  getLastDateClsoed():Observable<ApiResponse<any>>{
    let Url:any = 'https://crmapi.valeriahotels.com/api/stock-closings/last';
    Url = Url + '?groupId='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
     return this.http.get<ApiResponse<any>>(Url);
  }
  
  
    // .map(() => { return true; })
    // .catch((e) => (e));
  
  getAllTags(): Observable<ApiResponse<any>> {
    return this.http.get<ApiResponse<any>>(`${this.apiRootRED}//tags`);
  }
  getAllRoles(): Observable<ApiResponse<any>> {
    return this.http.get<ApiResponse<any>>(`${this.apiRootRED}/roles`);
  }
  getAllUsers(): Observable<ApiResponse<any>> {
    return this.http.get<ApiResponse<any>>(`${this.apiRootRED}/users`);
  }
  getAllProducts<T>(page): Observable<T> {
    let url = `${this.apiRoot}/listproducts?name=&page=${page}`;

    return this.http.get<T>(url);
  }
  updateProductType(subFamily: any): Observable<any> {
    const groupId = JSON.parse(localStorage.getItem('userDetails') || '{}')?.group?.groupId || 1;
  
    const payload = {
      productTypeId: subFamily.productTypeId,
      name: subFamily.name?.trim() || '',
      nameEn: subFamily.nameEn?.trim() || '',
      alternativeName: subFamily.alternativeName?.trim() || '',
      sorting: Number(subFamily.sorting) || 0,
      description: subFamily.description?.trim() || '',
      code: subFamily.code?.trim() || '',
      icon: subFamily.icon || null,
      image: subFamily.image || null,
      groups: (groupId === 1 || groupId === 2) ? [1, 2] : [groupId]
    };
  
    return this.http.post(`${this.apiRootRED}/producttype?group=${groupId}`, payload);
  }
  getAllPos(grp:any):Observable<any>{
    let url = `${this.apiRootRED}/pos?&group=`+grp;
    return this.http.get<any>(url);
  }
  getallUinty():Observable<any>{
    let url = `${this.apiRootRED}/unit/custom/types`;
    return this.http.get<any>(url);
  }
  getProductById(id: any): Observable<Product> {
    console.log('prod service');
    if (id === 'new') {
      const productInstance: ProductCtor = new ProductCtor({
        reference: null,
        producType:null,
        name: null,
        contents: [],
        salesSpitch: [],
        photos: [],
        rateGroups: [],
        ratings: [],
        prices: [],
        customerRating: [],
        supplier: null,
        tags: [],
        user:null,
        unitType:null,
      });
      return of(productInstance);
    }
    let url = `${this.apiRootRED}/product/${id}`;

    return this.http.get<Product>(url);
  }


  updateInitialStockByRealStock(groupId: number, posId: number, dateFrom: string, dateTo: string): Observable<any> {
    const url = `${this.apiRootRED}/update/initial/by/realstocks/-1/${posId}`;
    const params = new HttpParams()
      .set('dfrom', dateFrom)
      .set('dto', dateTo);
    
    return this.http.post(url, {}, { params });
  }


  addProductType(prod: ProductType) {
    console.log("prod",prod);
    // https://crmapi.valeriahotels.com/api/product
    let url = `${this.apiRootRED}/producttype`;

    return this.http.post<ApiResponse<ProductType>>(url, prod, { observe: 'response' });
  }
  addProduct(prod: Product) {
    console.log("prod",prod);
    // https://crmapi.valeriahotels.com/api/product
    let url = `${this.apiRootRED}/product`;

    return this.http.post<ApiResponse<Product>>(url, prod, { observe: 'response' });
  }
  updateProduct(prod: Product, id: any) {
    let url = `${this.apiRootRED}/product/${id}`;
    console.log('updateProduct', url, prod);
    return this.http.put<ApiResponse<Product>>(url, prod, { observe: 'response' });
  }
  deleteProduct(id: any) {
    let url = `${this.apiRootRED}/product/${id}`;
    return this.http.delete<ApiResponse<Product>>(url,{ observe: 'response' });
  }
  getProductByName(name:string) {
    let url = `${this.apiRootRED}/listproducts/v2?&name=${name}`;
    return this.http.get(url).pipe(
      map((res: ApiResponse<Product>) => {
        return res.content;
      })
    );
  }
  getSupplierByName(term: string){
    let url = `${this.apiRootRED}/suppliers?criteria=${term}&group=-1`;
    return this.http.get(url).pipe(
      map((res: ApiResponse<Client>) => {
        return res.content;
      })
    );
  } 
  // getAllsupliers(): Observable<Client[]> {
  //   const url = `${this.apiRootRED}/suppliers`;
  //   return this.http.get(url).pipe(
  //     map((res: ApiResponse<Client>) => {
  //       return res.content;
  //     })
  //   );
  // }
  getAllSuppliers(page: number): Observable<ApiResponse<Client[]>> {
    const url = `${this.apiRootRED}/suppliers?group=-1&size=20`;
    const params = new HttpParams().set('page', page.toString());

    return this.http.get(url, { params }).pipe(
      map((res: ApiResponse<Client[]>) => {
        return res;
      })
    );
  }
  getCustomerByName(term: string): Observable<Client[]> {
    const url = `${this.apiRootRED}/customers?criteria=${term}&group=-1`;
    return this.http.get<ApiResponse<Client>>(url).pipe(
      map((res: ApiResponse<Client>) => {
        return res.content;
      })
    );
  }
  getAllCustomers(): Observable<Client[]> {
    const url = `${this.apiRootRED}/customers?page=0`;
    return this.http.get<ApiResponse<Client>>(url).pipe(
      map((res: ApiResponse<Client>) => {
        return res.content;
      })
    );
  }
  getAllCustomersBySearch(term: string): Observable<Client[]> {
    const url = `${this.apiRootRED}/prospects?criteria=${term}&group=-1`;
    return this.http.get<ApiResponse<Client>>(url).pipe(
      map((res: ApiResponse<Client>) => {
        return res.content;
      })
    );
  }
  getAllCustomersBySearchK(term: string): Observable<any> {
    const url = `${this.apiRootRED}/prospects?criteria=${term}&group=-1`;
    return this.http.get<ApiResponse<Client>>(url).pipe(
        map((res: ApiResponse<Client>) => {
          return res;
        })
    );
  }

  getAllCustomersBySearchKandPage(term: string,page: number,size:number): Observable<any> {
    return this.http.get<ApiResponse<Client>>(`${this.apiRootRED}/customers?`, {
      params: new HttpParams()
          .set('criteria',term)
          .set('page', page.toString())
          .set('size', size.toString())
    });
  }

  getAllUsersAddBySerach(term:string,page: number, pageSize: number): Observable<any> {
    let LnkUsers = `${this.apiRootRED}/users?`+'group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId
    return this.http.get<ApiResponse<Client>>(LnkUsers, {
      params: new HttpParams()
          .set('name',term)
          .set('page', page.toString())
          .set('size', pageSize.toString())
    });
  }
  getAllSupplierAddBySerach(term:string,page: number, pageSize: number): Observable<any> {
    let LnkUsers = `${this.apiRootRED}/suppliers?`+'group=-1';
    return this.http.get<ApiResponse<Client>>(LnkUsers, {
      params: new HttpParams()
          .set('criteria',term)
          .set('page', page.toString())
          .set('size', pageSize.toString())
    });
  }
  // getAllCustomersA(page: number): Observable<Client[]> {
  //   const url = `${this.apiRootRED}/api/customers?page=${page}`;
  //   return this.http.get<ApiResponse<Client>>(url).pipe(
  //     map((res: ApiResponse<Client>) => {
  //       return res.content;
  //     })
  //   );
  // }
  getAllCustomersA(page:number,itemsPerPage: number): Observable<Client[]> {
   
    // Initial request for the first page
    return this.http.get<ApiResponse<Client>>(`${this.apiRootRED}/customers?page=${page}`)
      .pipe(
        map((res: ApiResponse<Client>) => res.content),
        // Use the expand operator to keep making requests until there are no more pages
        expand((data: Client[]) => {
          if (data.length === itemsPerPage) {
            return this.http.get<ApiResponse<Client>>(`${this.apiRootRED}/customers?page=0`)
              .pipe(map((res: ApiResponse<Client>) => res.content));
         } else {
            return [];
          }
        }),
        // Use the takeWhile operator to stop making requests once there are no more pages
        takeWhile((data: Client[]) => data.length === itemsPerPage)
      );
  }
  getCityByName(term: string): Observable<any> {
    const url = `https://locations.atlasvoyages.com/apollo-giata/api/pois?lang=en&qt=byName&str=${term}`;
    return this.http.get(url).pipe(
      map((res: ApiResponse<any>) => {
        return res;
      })
    );
  }
  getCountryByName(term: string): Observable<Country[]> {
    const url = `${this.apiRootRED}/countries?name=${term}&lang=fr`;
    return this.http.get<ApiResponse<Country>>(url).pipe(
      map((res: ApiResponse<Country>) => {
        return res.content;
      })
    );
  }
  
  filterProducts(type, city, number, duration, supplier, page) {
    let url = `${this.apiRoot}/listproducts?page=${page}&name=`;
    if (type != '') {
      url = url + `&type=${type}`;
    }
    if (city != '') {
      url = url + `&city=${city}`;
    }
    if (number != '') {
      url = url + `&number=${number}`;
    }
    if (duration != '') {
      url = url + `&duration=${duration}`;
    }
    if (supplier != '') {
      url = url + `&supplier=${supplier}`;
    }
    return this.http.get(url);
  }
  getAllPaymentMethodes(): Observable<ApiResponse<any>> {
    return this.http.get<ApiResponse<any>>(`${this.apiRootRED}/paymentmethods`);
  }
  
  addClient(client: Client) {
    var url;
    if (client.personType == 'NATURAL') {
      url = `${this.apiRootRED}/naturalpersons`;
    } else {
      client.name = client.socialReason;
      url = `${this.apiRootRED}/legalpersons`;
    }
    return this.http.post<ApiResponse<Client>>(url, client, { observe: 'response' });
  }
  getAllGenders(): Observable<ApiResponse<any>> {
    return this.http.get<ApiResponse<any>>(`${this.apiRootRED}/genders`);
  }
  getAllLegalFormsFunctions(): Observable<ApiResponse<LegalForm>> {
    return this.http.get<ApiResponse<LegalForm>>(`${this.apiRootRED}/alllegalforms`);
  }

  getAllCustomersK(page: number, pageSize: number): Observable<any> {
    return this.http.get<ApiResponse<Client>>(`${this.apiRootRED}/customers?`, {
      params: new HttpParams()
          .set('page', page.toString())
          .set('size', pageSize.toString())
    });
  }
  getAllUsersAdd(page: number, pageSize: number): Observable<any> {
    let LnkUsers = `${this.apiRootRED}/users?`+'group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId
    return this.http.get<ApiResponse<Client>>(LnkUsers, {
      params: new HttpParams()
          .set('page', page.toString())
          .set('size', pageSize.toString())
    });
  }
  getAllSupplierAdd(page: number, pageSize: number): Observable<any> {
    let LnkUsers = `${this.apiRootRED}/suppliers?`+'group=-1'
    return this.http.get<ApiResponse<Client>>(LnkUsers, {
      params: new HttpParams()
          .set('page', page.toString())
          .set('size', pageSize.toString())
    });
  }
  Move(todelete:any,target:any){
    const url = `${this.apiRootRED}/delete/product/${todelete}/transfer/to/${target}`;
    return this.http.get(url);
  }
 


  createFamily(name: string): Observable<any> {
    const url = `${this.apiRoot}/product/family`;
    return this.http.post(url, { name });
  }
  
  
  createSubFamily(name: string): Observable<any> {
    const url = `${this.apiRoot}/producttype`;
    return this.http.post(url, {name});
  }

  createFamille(family: any): Observable<any> {
    const userDetails = JSON.parse(localStorage.getItem("userDetails") || '{}');
    const groupId = userDetails?.group?.groupId;
  
    const sharedPayload = {
      name: family.name,
      nameEn: family.nameEn,
      alternativeName: family.alternativeName,
      description: family.description || null,
      icon: null,
      image: null
    };
  
    const payload = {
      ...sharedPayload,
      groups: (groupId === 1 || groupId === 2) ? [1, 2] : [groupId]
    };
  
    return this.http.post(`${this.apiRootRED}/product/family`, payload);
  }
  

  PutedFamille(family: any): Observable<any> {
    if (!family?.productFamilyId) {
      console.error("productFamilyId is missing");
      return of(null); // empêche la requête invalide
    }
  
    console.log("Updating family:", family);
    return this.http.put(`${this.apiRootRED}/product/family`, family);
  }

  LinkFamilleSubFamily(family: any,subFamily:any): Observable<any> {
    return this.http.get(`${this.apiRootRED}/producttpe/${subFamily.productTypeId}/addtofamily/${family.productFamilyId}`);
  }
  
  DetachedFamilleSubFamily(family: any,subFamily:any): Observable<any> {
    return this.http.get(`${this.apiRootRED}/producttpe/${subFamily.productTypeId}/removefromfamily/${family.productFamilyId}`);
  }
  

  DeletedFamily(family: any): Observable<any> {
    return this.http.delete(`${this.apiRootRED}/product/family/${family.productFamilyId}`);
  }

  createProductType(type: any): Observable<any> {
    const userDetails = JSON.parse(localStorage.getItem("userDetails") || '{}');
    const groupId = userDetails?.group?.groupId;
  
    const sharedPayload = {
      name: type.name,
      nameEn: type.nameEn,
      alternativeName: type.alternativeName,
      description: type.description || null,
      icon: null,
      image: null,
      sorting:type.sorting
    };
  
    const payload = {
      ...sharedPayload,
      groups: (groupId === 1 || groupId === 2) ? [1, 2] : [groupId]
    };
  
    return this.http.post(`${this.apiRootRED}/producttype`, payload);
  }
  

  
  linkFamilyToSubFamily(familyId: number, subFamilyId: number): Observable<any> {
    const groupId = JSON.parse(localStorage.getItem("userDetails")).group.groupId;
    const body = { productFamilyId: familyId, productTypeId: subFamilyId };
    return this.http.post(`${this.apiRootRED}/product/allfamilies?group=${groupId}`, body);
  }
  
  // linkFamilyToSubFamily(familyId: number, subFamilyId: number): Observable<any> {
  //   const groupId = JSON.parse(localStorage.getItem("userDetails") || '{}')?.group?.groupId;
  
  //   if (!groupId) {
  //     throw new Error("Group ID introuvable dans localStorage.");
  //   }
  
  //   const body = {
  //     productFamilyId: familyId,      // ex: 180127
  //     productTypeId: subFamilyId      // ex: 180126
  //   };
  
  //   return this.http.post(`${this.apiRootRED}/product/family?group=${groupId}`, body);
  // }
  

getAllFamille(): Observable<any> {
  const groupId = JSON.parse(localStorage.getItem("userDetails")).group.groupId;
  return this.http.get<any>(`${this.apiRootRED}/product/allfamilies?group=${groupId}`);
}
getAllFamilleV2(groupId:any): Observable<any> {
  // const groupId = JSON.parse(localStorage.getItem("userDetails")).group.groupId;
  return this.http.get<any>(`${this.apiRootRED}/product/allfamilies?group=${groupId}`);
}

getAllProductTypes(): Observable<any> {
  const groupId = JSON.parse(localStorage.getItem("userDetails")).group.groupId;
  return this.http.get<any>(`${this.apiRootRED}/allaproducttypes?group=${groupId}`);
}

  

  
}
